<mat-spinner *ngIf="loading" class="loading-spinner" [diameter]="70"></mat-spinner>
<div class="container" *ngIf="!loading && order">
    <div class="heading-container">
        <p class="header">{{ "order.heading.orderDetail" | translate }} :</p>
        <p></p>
    </div>
    <app-order-timeline *ngIf="showTimeline" [statusHistory]="filteredStatusHistory!"></app-order-timeline>

    <div class="subtitle">
        <span class="orderedOn"
            >{{ "order.orderDetails.orderOn" | translate }} {{ order.createdAt | date: "dd MMMM y" }}</span
        >
        <span>|</span>
        <span class="orderId">{{ "order.orderDetails.orderId" | translate }}# {{ order.id }}</span>
    </div>

    <div class="card items" *ngIf="nonCancelledItems.length">
        <h2 class="title">{{ "order.heading.items" | translate }}</h2>
        <div *ngIf="cancellableItems.length || returnableItems.length || exchangeableItems.length" class="btn-content">
            <div
                class="content"
                *ngIf="
                    order.orderStatus === OrderStatus.Delivered ||
                    order.orderStatus === OrderStatus.Returned ||
                    order.orderStatus === OrderStatus.Ordered ||
                    order.orderStatus === OrderStatus.Packed
                "
            >
                <div class="checkbox-content" *ngIf="isSelectAllVisible()">
                    <mat-checkbox
                        [indeterminate]="isSomeSelected()"
                        (change)="toggleSelectAll($event)"
                        [checked]="isAllSelected()"
                    >
                        {{ "order.checkbox.selectAll" | translate }}
                    </mat-checkbox>
                </div>
                &nbsp;&nbsp;
                <button
                    class="exchange-btn"
                    mat-flat-button
                    *ngIf="exchangeableItems.length"
                    (click)="openExchangeDialog(order)"
                    [disabled]="!this.selectedItemIds.length"
                >
                    {{ "order.button.exchangeBtn" | translate }}
                </button>
            </div>
            &nbsp;&nbsp;
            <button
                class="save-btn"
                mat-flat-button
                *ngIf="cancellableItems.length || returnableItems.length"
                (click)="cancelOrReturn(order)"
                [disabled]="!this.selectedItemIds.length"
            >
                {{
                    cancellableItems.length
                        ? ("order.button.cancelBtn" | translate)
                        : ("order.button.returnBtn" | translate)
                }}
            </button>
        </div>

        <div class="product-card" *ngFor="let item of nonCancelledItems">
            <div class="checkbox-container" *ngIf="isItemSelectable(item.id!)">
                <mat-checkbox (change)="toggleItemSelection(item.id!, $event.checked)" [checked]="isSelected(item.id!)">
                </mat-checkbox>
            </div>

            <div class="prod-img-container">
                <img
                    *ngIf="item.product?.images?.imagesUrl?.[0]"
                    [src]="item.product?.images?.imagesUrl?.[0]"
                    class="image"
                />
                <div *ngIf="!item.product?.images?.imagesUrl?.[0]" class="image"></div>
            </div>

            <div class="details">
                <div class="product-name">
                    <p
                        *ngIf="item.product?.name"
                        [matTooltip]="item.product?.name || ''"
                        [matTooltipShowDelay]="500"
                        [matTooltipHideDelay]="500"
                        [matTooltipDisabled]="!isOverflow(productName)"
                        #productName
                    >
                        {{ item.product?.name }}

                        <!-- Total No. of Blocks -->
                        <span *ngIf="item.product?.modelQuantityJson">
                            ({{ item.product?.modelQuantityJson?.totalBlock }}
                            {{ "order.orderDetails.shape" | translate }})
                        </span>
                    </p>
                </div>

                <!-- To View the Blocks Count -->
                <span
                    *ngIf="item.product?.modelQuantityJson"
                    class="view-count"
                    (click)="getCountInfo(item.product?.modelQuantityJson?.modelInfoUrl)"
                >
                    {{ "order.orderDetails.viewCount" | translate }}
                </span>

                <div class="link" *ngIf="showStructureLink(item.product!)">
                    <mat-icon (click)="goToStructureFromOrder(item.product?.id ?? 0)">link</mat-icon>
                </div>

                <div class="quantity">
                    <p>{{ "order.orderDetails.quantity" | translate }}: {{ item.quantity }}</p>
                </div>

                <div class="price">
                    <p>{{ "currency.rs" | translate }}{{ item.discountedPrice || item.price }}</p>
                </div>

                <div class="returned-status">
                    <p>
                        {{ "order.orderDetails.orderStatus" | translate }}:
                        <span [ngClass]="getOrderStatusClasses(item)">{{ item.itemStatus }}</span>
                    </p>
                </div>
            </div>

            <div class="exchange-review">
                <button
                    *ngIf="showReviewBtn(item)"
                    mat-flat-button
                    class="save-btn"
                    [disabled]="isReviewDisabled(item.product)"
                    (click)="openRatingPopup(item.product, order)"
                >
                    {{ "order.button.addReviewBtn" | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="card items" *ngIf="cancelledItems.length">
        <h2 class="title">{{ "order.heading.cancelItems" | translate }}</h2>
        <div class="product-card" *ngFor="let item of cancelledItems">
            <div class="prod-img-container">
                <img
                    *ngIf="item.product?.images?.imagesUrl?.[0]"
                    [src]="item.product?.images?.imagesUrl?.[0]"
                    class="image"
                />
                <div *ngIf="!item.product?.images?.imagesUrl?.[0]" class="image"></div>
            </div>

            <div class="details">
                <div class="product-name">
                    <p
                        *ngIf="item.product?.name"
                        [matTooltip]="item.product?.name || ''"
                        [matTooltipShowDelay]="500"
                        [matTooltipHideDelay]="500"
                        [matTooltipDisabled]="!isOverflow(productName)"
                        #productName
                    >
                        {{ item.product?.name }}

                        <!-- Total No. of Blocks -->
                        <span *ngIf="item.product?.modelQuantityJson">
                            ({{ item.product?.modelQuantityJson?.totalBlock }}
                            {{ "order.orderDetails.shape" | translate }})
                        </span>
                    </p>
                </div>

                <!-- To View the Blocks Count-->
                <span
                    *ngIf="item.product?.modelQuantityJson"
                    class="view-count"
                    (click)="getCountInfo(item.product?.modelQuantityJson?.modelInfoUrl)"
                >
                    {{ "order.orderDetails.viewCount" | translate }}
                </span>

                <div class="link" *ngIf="showStructureLink(item.product!)">
                    <mat-icon (click)="goToStructureFromOrder(item.product?.id ?? 0)">link</mat-icon>
                </div>

                <div class="quantity">
                    <p>{{ "order.orderDetails.quantity" | translate }}: {{ item.quantity }}</p>
                </div>

                <div class="price">
                    <p>{{ "currency.rs" | translate }}{{ item.discountedPrice || item.price }}</p>
                </div>
                <div>
                    <p>
                        {{ "order.orderDetails.orderStatus" | translate }}:
                        <span [ngClass]="getOrderStatusClasses(item)">{{ item.itemStatus }}</span>
                    </p>
                </div>
                <div class="cancel-refund-status">
                    <p *ngIf="order.paymentMethod === PaymentMethod.OnlinePayment">
                        {{ "order.orderDetails.refundStatus" | translate }}:
                        <span [ngClass]="getRefundStatusClass(item.refund?.refundStatus)">{{
                            item.refund?.refundStatus
                        }}</span>
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="card items" *ngIf="returnedItems.length">
        <h2 class="title">{{ "order.heading.returnItems" | translate }}</h2>
        <div class="product-card" *ngFor="let item of returnedItems">
            <div class="prod-img-container">
                <img
                    *ngIf="item.product?.images?.imagesUrl?.[0]"
                    [src]="item.product?.images?.imagesUrl?.[0]"
                    class="image"
                />
                <div *ngIf="!item.product?.images?.imagesUrl?.[0]" class="image"></div>
            </div>

            <div class="details">
                <div class="product-name">
                    <p
                        *ngIf="item.product?.name"
                        [matTooltip]="item.product?.name || ''"
                        [matTooltipShowDelay]="500"
                        [matTooltipHideDelay]="500"
                        [matTooltipDisabled]="!isOverflow(productName)"
                        #productName
                    >
                        {{ item.product?.name }}

                        <!-- Total No. of Blocks -->
                        <span *ngIf="item.product?.modelQuantityJson">
                            ({{ item.product?.modelQuantityJson?.totalBlock }}
                            {{ "order.orderDetails.shape" | translate }})
                        </span>
                    </p>
                </div>

                <!-- To View the Blocks Count -->
                <span
                    *ngIf="item.product?.modelQuantityJson"
                    class="view-count"
                    (click)="getCountInfo(item.product?.modelQuantityJson?.modelInfoUrl)"
                >
                    {{ "order.orderDetails.viewCount" | translate }}
                </span>

                <!-- structure link -->
                <div class="link" *ngIf="showStructureLink(item.product!)">
                    <mat-icon (click)="goToStructureFromOrder(item.product?.id ?? 0)">link</mat-icon>
                </div>

                <div class="quantity">
                    <p>{{ "order.orderDetails.quantity" | translate }}: {{ item.quantity }}</p>
                </div>

                <div class="price">
                    <p>{{ "currency.rs" | translate }}{{ item.discountedPrice || item.price }}</p>
                </div>

                <div class="status">
                    <div>
                        <p class="order-status">
                            {{ "order.orderDetails.orderStatus" | translate }} :
                            <span [ngClass]="getOrderStatusClasses(item)">{{ item.itemStatus }}</span>
                        </p>
                    </div>
                    <div *ngIf="item.refund?.refundStatus">
                        <p class="status-refund">
                            {{ "order.orderDetails.refundStatus" | translate }} :
                            <span [ngClass]="getRefundStatusClass(item.refund?.refundStatus)">{{
                                item.refund?.refundStatus
                            }}</span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="ratingAndReview">
                <button
                    *ngIf="
                        item.itemStatus === OrderStatus.Delivered ||
                        item.itemStatus === OrderStatus.ReturnInitiated ||
                        item.itemStatus === OrderStatus.PickupScheduled ||
                        item.itemStatus === OrderStatus.Returned
                    "
                    mat-flat-button
                    class="save-btn"
                    [disabled]="isReviewDisabled(item.product)"
                    (click)="openRatingPopup(item.product, order)"
                >
                    {{ "order.button.addReviewBtn" | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="card items" *ngIf="exchangeItems.length">
        <h2 class="title">{{ "order.heading.exchangeItems" | translate }}</h2>
        <div *ngIf="!nonCancelledItems.length && returnableItems.length" class="btn-content">
            <div class="checkbox-content" *ngIf="exchangeItems.length > 1">
                <mat-checkbox
                    [indeterminate]="isSomeSelected()"
                    (change)="toggleSelectAll($event)"
                    [checked]="isAllSelected()"
                ></mat-checkbox>
                <span class="s-text">{{ "order.checkbox.selectAll" | translate }}</span>
            </div>
            &nbsp;&nbsp;
            <button
                class="save-btn"
                mat-flat-button
                (click)="openDialogReturn()"
                [disabled]="!this.selectedItemIds.length"
            >
                {{ "order.button.returnBtn" | translate }}
            </button>
        </div>
        <div class="product-card" *ngFor="let item of exchangeItems">
            <div class="checkbox-container" *ngIf="isItemSelectable(item.id!)">
                <mat-checkbox
                    *ngIf="isRecentDeliveredOrExchangedItem(item)"
                    (change)="toggleItemSelection(item.id!, $event.checked)"
                    [checked]="isSelected(item.id!)"
                ></mat-checkbox>
            </div>
            <div class="prod-img-container">
                <img
                    *ngIf="item.product?.images?.imagesUrl?.[0]"
                    [src]="item.product?.images?.imagesUrl?.[0]"
                    class="image"
                />
                <div *ngIf="!item.product?.images?.imagesUrl?.[0]" class="image"></div>
            </div>

            <div class="details">
                <div class="product-name">
                    <p
                        *ngIf="item.product?.name"
                        [matTooltip]="item.product?.name || ''"
                        [matTooltipShowDelay]="500"
                        [matTooltipHideDelay]="500"
                        [matTooltipDisabled]="!isOverflow(productName)"
                        #productName
                    >
                        {{ item.product?.name }}

                        <!-- Total No. of Blocks -->
                        <span *ngIf="item.product?.modelQuantityJson">
                            ({{ item.product?.modelQuantityJson?.totalBlock }}
                            {{ "order.orderDetails.shape" | translate }})
                        </span>
                    </p>
                </div>
                <!-- To View the Blocks Count -->
                <span
                    *ngIf="item.product?.modelQuantityJson"
                    class="view-count"
                    (click)="getCountInfo(item.product?.modelQuantityJson?.modelInfoUrl)"
                >
                    {{ "order.orderDetails.viewCount" | translate }}
                </span>

                <!-- structure link -->
                <div class="link" *ngIf="showStructureLink(item.product!)">
                    <mat-icon (click)="goToStructureFromOrder(item.product?.id ?? 0)">link</mat-icon>
                </div>

                <div class="quantity">
                    <p>{{ "order.orderDetails.quantity" | translate }}: {{ item.quantity }}</p>
                </div>

                <div class="price">
                    <p>{{ "currency.rs" | translate }}{{ item.discountedPrice || item.price }}</p>
                </div>
                <div class="status">
                    <div>
                        <p class="order-status">
                            {{ "order.orderDetails.orderStatus" | translate }}:
                            <span [ngClass]="getOrderStatusClasses(item)">{{ item.itemStatus }}</span>
                        </p>
                    </div>
                    <div>
                        <p class="status-refund">
                            {{ "order.orderDetails.refundStatus" | translate }}:
                            <span [ngClass]="getRefundStatusClass(item.refund?.refundStatus)">{{
                                item.refund?.refundStatus
                            }}</span>
                        </p>
                    </div>
                </div>
            </div>

            <div class="exchange-review">
                <button
                    *ngIf="item.itemStatus === OrderStatus.Exchanged"
                    mat-flat-button
                    class="save-btn"
                    [disabled]="isReviewDisabled(item.product)"
                    (click)="openRatingPopup(item.product, order)"
                >
                    {{ "order.button.addReviewBtn" | translate }}
                </button>
            </div>
        </div>
    </div>

    <div class="card main">
        <div class="shippingAddress">
            <p class="main-title">{{ "order.orderDetails.shippingAddress" | translate }}</p>

            <p>{{ order.orderAddress?.shippingAddress?.name }}</p>
            <p>
                {{ order.orderAddress?.shippingAddress?.houseNumber }},
                {{ order.orderAddress?.shippingAddress?.address }}, {{ order.orderAddress?.shippingAddress?.city }},
                {{ order.orderAddress?.shippingAddress?.state }},
                {{ order.orderAddress?.shippingAddress?.pincode }}
            </p>
            <p>{{ order.orderAddress?.shippingAddress?.mobileNumber }}</p>
        </div>

        <div class="payment-details">
            <div class="payment-method">
                <p class="main-title">Payment Method</p>
                <p>{{ order.paymentMethod }}</p>
            </div>

            <div class="status">
                <p class="main-title">{{ "order.orderDetails.status" | translate }}</p>

                <span class="status-pair">
                    <p class="label">{{ "order.orderDetails.orderStatus" | translate }}:</p>
                    <p class="value" [ngClass]="getOrderStatusClasses()">
                        {{ order.orderStatus }}
                    </p>
                </span>

                <span class="status-pair">
                    <p class="label">{{ "order.orderDetails.paymentStatus" | translate }}:</p>
                    <p class="value" [ngClass]="getPaymentStatusClasses()">
                        {{ order.paymentStatus }}
                    </p>
                </span>

                <span class="status-pair" *ngIf="this.isAllRefundSuccessful">
                    <p class="label">{{ "order.orderDetails.refundStatus" | translate }}:</p>
                    <p class="refund-successful">
                        {{ refundStatusMessage }}
                    </p>
                </span>
            </div>
        </div>

        <div class="summary">
            <p class="main-title">{{ "order.orderDetails.orderSummary" | translate }}</p>

            <span class="pair">
                <p class="label">{{ "order.orderDetails.subTotal" | translate }}:</p>
                <p class="value">
                    {{ currency }}
                    {{ isOrderFullyCancelledOrReturned ? order.originalSubTotal : order.currentSubTotal }}
                </p>
            </span>
            <span class="pair">
                <p class="label">{{ "order.orderDetails.couponDiscount" | translate }}:</p>
                <p class="value">
                    - {{ currency }}
                    {{ isOrderFullyCancelledOrReturned ? order.originalCouponDiscount : order.currentCouponDiscount }}
                </p>
            </span>
            <span class="pair">
                <p class="label">{{ "order.orderDetails.shipping" | translate }}:</p>
                <p class="value">+ {{ currency }} {{ order.deliveryCharge }}</p>
            </span>
            <span class="pair fw-700">
                <p class="label">{{ "order.orderDetails.total" | translate }}:</p>
                <p class="value">
                    {{ currency }} {{ isOrderFullyCancelledOrReturned ? order.originalTotal : order.currentTotal }}
                </p>
            </span>
            <span class="pair">
                <p class="label">{{ "order.orderDetails.coinsUsed" | translate }}:</p>
                <p class="value">
                    {{ isOrderFullyCancelledOrReturned ? order.originalCoinsUsed : order.currentCoinsUsed }}
                </p>
            </span>
            <span class="pair fw-700">
                <p class="label">
                    {{
                        (order.paymentMethod === PaymentMethod.CashOnDelivery &&
                        (order.orderStatus === OrderStatus.Ordered ||
                            order.orderStatus === OrderStatus.Packed ||
                            order.orderStatus === OrderStatus.Dispatched ||
                            order.orderStatus === OrderStatus.Cancelled)
                            ? "order.orderDetails.payableAmount"
                            : "order.orderDetails.amountCharged"
                        ) | translate
                    }}:
                </p>
                <p class="value">
                    {{ currency }}
                    {{ isOrderFullyCancelledOrReturned ? order.originalPaymentAmount : order.currentPaymentAmount }}
                </p>
            </span>
        </div>
    </div>
</div>
<div *ngIf="noDataFound" class="no-data">
    {{ "order.heading.dataNotFound" | translate }}
</div>
